export const DEFAULT_IMAGE_DURATION = 10000;
